<mat-accordion multi class="expand-collapse-panel">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
    <form autocomplete="off" [formGroup]="form" id="filterContracts" class="filter-form">
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>Contract Number</mat-label>
          <input placeholder="Contract Number"
            title="Contract Number"
            matInput
            [matChipInputFor]="chipListContract"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event, 'contractnumbers')">
          </mat-form-field>
          <mat-chip-grid #chipListContract>
            @for (item of contractNumbers; track item) {
              <mat-chip-row
                [removable]="removable" (removed)="remove(item, 'contractnumbers')"
                matTooltip="{{item}}">
                <span class="chip-text">{{item}}</span>
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
        </div>
        <div class="filter-field">
          <mat-form-field class="search-input">
            <mat-label>Unit Id</mat-label>
            <input placeholder="Unit Id"
              title="Unit Id"
              matInput
              [matChipInputFor]="chipListUnits"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="applyFilter($event, 'unitids')">
            </mat-form-field>
            <mat-chip-grid #chipListUnits>
              @for (item of unitIds; track item) {
                <mat-chip-row
                  [removable]="removable" (removed)="remove(item, 'unitids')"
                  matTooltip="{{item}}">
                  <span class="chip-text">{{item}}</span>
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
          </div>
          <div class="filter-field">
            <mat-form-field class="search-input">
              <mat-label>Customer Id</mat-label>
              <input placeholder="Customer Id"
                title="Customer Id"
                matInput
                [matChipInputFor]="chipListCustomer"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="applyFilter($event, 'customerids')">
              </mat-form-field>
              <mat-chip-grid #chipListCustomer>
                @for (item of customerIds; track item) {
                  <mat-chip-row
                    [removable]="removable" (removed)="remove(item, 'customerids')"
                    matTooltip="{{item}}">
                    <span class="chip-text">{{item}}</span>
                    @if (removable) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip-row>
                }
              </mat-chip-grid>
            </div>
            <div class="filter-field">
              <mat-form-field class="search-input">
                <mat-label>Contract Line</mat-label>
                <input matInput
                  title="Contract Line"
                  placeholder="Contract Line"
                  [matChipInputFor]="chipListContractLine"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="applyFilter($event, 'contractlines')">
                </mat-form-field>
                <mat-chip-grid #chipListContractLine>
                  @for (item of contractLines; track item) {
                    <mat-chip-row
                      [removable]="removable" (removed)="remove(item, 'contractlines')"
                      matTooltip="{{item}}">
                      <span class="chip-text">{{item}}</span>
                      @if (removable) {
                        <mat-icon matChipRemove>cancel</mat-icon>
                      }
                    </mat-chip-row>
                  }
                </mat-chip-grid>
              </div>
              <div class="filter-field">
                <mat-form-field class="search-input">
                  <mat-label>Contract Line Locale</mat-label>
                  <input matInput
                    title="Contract Line Locale"
                    placeholder="Contract Line Locale"
                    [matChipInputFor]="chipListContractLineLocale"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="applyFilter($event, 'contractLinesLocale')">
                  </mat-form-field>
                  <mat-chip-grid #chipListContractLineLocale>
                    @for (item of contractLinesLocale; track item) {
                      <mat-chip-row
                        [removable]="removable" (removed)="remove(item, 'contractLinesLocale')"
                        matTooltip="{{item}}">
                        <span class="chip-text">{{item}}</span>
                        @if (removable) {
                          <mat-icon matChipRemove>cancel</mat-icon>
                        }
                      </mat-chip-row>
                    }
                  </mat-chip-grid>
                </div>
                <div class="filter-field">
                  <mat-form-field class="search-input">
                    <mat-label>Contract Type</mat-label>
                    <input matInput
                      title="Contract Type"
                      placeholder="Contract Type"
                      [matChipInputFor]="chipListContractType"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="addOnBlur"
                      (matChipInputTokenEnd)="applyFilter($event, 'contractTypes')">
                    </mat-form-field>
                    <mat-chip-grid #chipListContractType>
                      @for (item of contractTypes; track item) {
                        <mat-chip-row
                          [removable]="removable" (removed)="remove(item, 'contractTypes')"
                          matTooltip="{{item}}">
                          <span class="chip-text">{{item}}</span>
                          @if (removable) {
                            <mat-icon matChipRemove>cancel</mat-icon>
                          }
                        </mat-chip-row>
                      }
                    </mat-chip-grid>
                  </div>
                  <div class="filter-field">
                    <mat-form-field class="search-input">
                      <mat-label>Contract Type Locale</mat-label>
                      <input matInput
                        title="Contract Type Locale"
                        placeholder="Contract Type Locale"
                        [matChipInputFor]="chipListContractTypeLocale"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur"
                        (matChipInputTokenEnd)="applyFilter($event, 'contractTypesLocale')">
                      </mat-form-field>
                      <mat-chip-grid #chipListContractTypeLocale>
                        @for (item of contractTypesLocale; track item) {
                          <mat-chip-row
                            [removable]="removable" (removed)="remove(item, 'contractTypesLocale')"
                            matTooltip="{{item}}">
                            <span class="chip-text">{{item}}</span>
                            @if (removable) {
                              <mat-icon matChipRemove>cancel</mat-icon>
                            }
                          </mat-chip-row>
                        }
                      </mat-chip-grid>
                    </div>
                    <div class="filter-actions">
                      <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
                        {{ changeTypeButton() ? 'Reset' : 'Filter' }}
                      </button>
                    </div>
                    @if (anyFilterApplied) {
                      <div class="filter-row-toggle">
                        <div class="mat-slide-toggle-container">
                          <span style="margin-right:5px" [ngClass]="{'disabledText': showActiveToggle.checked, 'enabledText': !showActiveToggle.checked}">Show All</span>
                          <mat-slide-toggle class="custom-slide-toggle" #showActiveToggle formControlName="showOnlyActive" (change)="toggleActive($event)"></mat-slide-toggle>
                          <span style="margin-left:5px" [ngClass]="{'disabledText': !showActiveToggle.checked, 'enabledText': showActiveToggle.checked}">Show Active</span>
                        </div>
                      </div>
                    }
                  </form>
                </mat-expansion-panel>
              </mat-accordion>